// @view/workspace/document-selection/DocumentListSection.view.tsx
import React from "react";
import * as styles from "@styles/DocumentSelection.css";
import type { DocumentSelectionViewProps } from "@ps-bridge/contracts/documentSelection";
import type { DocumentMetadata } from "@ps-bridge/models/core/dataContracts";

type DocumentListSectionContractProps = Pick<DocumentSelectionViewProps, never>;

type DocumentListSectionViewProps = DocumentListSectionContractProps & {
  title: string;
  documents: DocumentMetadata[];
  renderDocumentItem: (doc: DocumentMetadata) => React.ReactElement;
  gridClassName: string;
};

const DocumentListSectionView: React.FC<DocumentListSectionViewProps> = ({
  title,
  documents,
  renderDocumentItem,
  gridClassName,
}) => (
  <div className={styles.categoryContainer}>
    <p className={styles.categoryHeading}>{title}</p>
    <div className={gridClassName}>
      {documents.map(renderDocumentItem)}
    </div>
  </div>
);

export default DocumentListSectionView;
